import * as React from 'react';
import { Title, ConfirmationModalContent } from '@zen-common/components-base';
import { NamingAssetStore } from '@zen/common-app-parts';
import getConfirmExecutionDetails from '../modules/getConfirmExecutionDetails';

export default function ConfirmMakeTake({
  title,
  onCancel,
  onConfirm,
  cancelText,
  original,
  rounded,
  asset,
  command,
  isBuy,
  quote,
}) {
  const { state: naming } = NamingAssetStore.useStore();

  const { Content, Subtitle } = getConfirmExecutionDetails({
    original,
    rounded,
    asset,
    command,
    isBuy,
    naming,
    quote,
  });

  return (
    <ConfirmationModalContent
      title={<Title>{title}</Title>}
      subtitle={<Subtitle />}
      confirmText="Continue"
      cancelText={cancelText}
      onCancel={onCancel}
      onConfirm={onConfirm}
    >
      <Content />
    </ConfirmationModalContent>
  );
}
